<template>
    <div>
        <!-- Desktop table -->
        <div class="d-none d-md-table measurements-table desktop-measurements-table">
            <div class="images-row" v-if="$backendConfig.settings.sex === 'male'">
                <div></div>
                <div v-for="(weight, id) in settings.weights" :key="id">
                    <img :src="$imageUrl($backendConfig.settings.sex + '-' + id + '.svg')" :alt="weight.title">
                    <HelperTooltip position="bottom">
                        <h5>{{ weight.title }}</h5>
                        <p>{{ weight.description }}</p>
                        <dl v-if="weight.parameters">
                            <div v-for="(item, index) in weight.parameters" :key="index">
                                <dt>{{ item.title }}:</dt>
                                <dd>{{ item.value }}</dd>
                            </div>
                        </dl>
                    </HelperTooltip>
                </div>
            </div>
            <div class="header-row">
                <div></div>
                <div v-for="(weight, id) in settings.weights" :key="id"
                     :class="{ hover: hoveredCol === id }">
                    {{ weight.title }}
                </div>
            </div>
            <div v-for="(height, hId) in settings.heights" :key="hId">
                <div>
                    <img :src="$imageUrl($backendConfig.settings.sex + '-' + hId + '.svg')" :alt="height.title">
                    <strong>{{ height.title }}</strong>
                    <span v-html="height.description"></span>
                </div>
                <div v-for="(weight, wId) in settings.weights" :key="wId"
                     :class="{ selected: cellIsActive(wId, hId) }"
                     @mouseenter="hoveredCol = wId" @mouseleave="hoveredCol = null" @click="toggleCell(wId, hId)">
                    <span>{{ cellText(height, weight) }}</span>
                </div>
            </div>
        </div>

        <!-- Mobile table -->
        <div class="d-table d-md-none measurements-table mobile-measurements-table" :class="{ larger: $backendConfig.settings.sex === 'female' }">
            <div class="header-row">
                <div></div>
                <div v-for="(hId, index) in Object.keys(settings.heights).reverse()" :key="index"
                     :class="{ selected: cellIsActive(null, hId) }">
                    <strong>{{ settings.heights[hId].title }}</strong>
                    <span v-html="settings.heights[hId].description"></span>
                </div>
            </div>
            <div v-for="(weight, wId, index) in settings.weights" :key="wId">
                <div :class="{ selected: cellIsActive(wId, null) }">
                    {{ weight.title }}
                    <HelperTooltip :position="index < 2 ? 'right' : 'right-top'"
                                   v-if="$backendConfig.settings.sex === 'male'">
                        <h5>{{ weight.title }}</h5>
                        <p>{{ weight.description }}</p>
                        <dl v-if="weight.parameters">
                            <div v-for="(item, index) in weight.parameters" :key="index">
                                <dt>{{ item.title }}:</dt>
                                <dd>{{ item.value }}</dd>
                            </div>
                        </dl>
                    </HelperTooltip>
                </div>
                <template v-for="hId in Object.keys(settings.heights).reverse()">
                    <div>
                        <span class="radio-container" @click.prevent="toggleCell(wId, hId)">
                            <input type="radio" name="measurements-table-radio" :checked="cellIsActive(wId, hId)">
                            <span class="checkmark"></span>
                        </span>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import HelperTooltip from "../common/HelperTooltip";

export default {
    name: "MeasurementsTable",
    components: {HelperTooltip},
    data() {
        return {
            hoveredCol: null,
            settings: null,
        };
    },
    computed: {
        selectedCell: {
            get() {
                return this.$db.measurements["table-size"] || null;
            },
            set(value) {
                this.$set(this.$db.measurements, "table-size", value);
            }
        }
    },
    methods: {
        toggleCell(weight, height) {
            if (this.cellIsActive(weight, height))
                this.selectedCell = null;
            else
                this.selectedCell = {
                    weight, height
                };
        },

        cellIsActive(weight, height) {
            return this.selectedCell && (this.selectedCell.weight === weight || weight === null) && (this.selectedCell.height === height || height === null);
        },

        cellText(height, weight) {
            let w = weight.title;

            // Czech male -> lowercase
            if (this.$backendConfig.settings.sex === "male" && this.$backendConfig.settings.language === "cs")
                w = w.toLowerCase();

            return height.title + " " + w;
        }
    },
    created() {
        this.settings = this.$backendConfig["measurements-table"];
    }
}
</script>
